export class ServiceAttendanceAdjustmentItem {
    index: number;
    serviceConceptId: number;
    serviceConceptTypeName: string;
    actual: number;
    adjust: number;
    total: number;
    edited: boolean;
}